{
  "common": {
    "save": "Save",
    "save_changes": "Save Changes",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "view": "View",
    "create": "Create",
    "search": "Search",
    "back": "Back",
    "add": "Add",
    "remove": "Remove",
    "submit": "Submit",
    "confirm": "Confirm",
    "close": "Close",
    "done": "Done",
    "next": "Next",
    "previous": "Previous",
    "loading": "Loading…",
    "no_data": "No data yet",
    "not_found": "Not found",
    "required": "Required",
    "optional": "Optional",
    "all": "All",
    "new": "New",
    "yes": "Yes",
    "no": "No",
    "logout": "Log out",
    "actions": "Actions",
    "status": "Status",
    "total": "Total",
    "filter": "Filter",
    "today": "Today",
    "days": "days",
    "hours": "hrs",
    "months": "mo",
    "success": "Success",
    "updated": "Updated",
    "failed": "Failed",
    "error": "Error",
    "try_again": "Please try again",
    "err_validation": "Please check the highlighted fields",
    "err_unauthorized": "Your session has expired — please sign in again",
    "err_forbidden": "You don't have permission to do that",
    "err_not_found": "We couldn't find what you were looking for",
    "err_conflict": "That conflicts with an existing record",
    "err_network": "Network problem — check your connection and try again",
    "err_berth_overlap": "That berth is already booked for those dates",
    "err_negative_stock": "Stock cannot go below zero",
    "err_has_relations": "Remove related records first, then try again",
    "err_invalid_state": "That action isn't available in the current status",
    "err_generic": "Something went wrong on our side. Please try again.",
    "see_more": "View →",
    "draft": "Draft",
    "send": "Send",
    "notes": "Notes",
    "name": "Name",
    "email": "Email",
    "phone": "Phone",
    "country": "Country",
    "showing": "{{first}}–{{last}} of {{total}} records"
  },
  "nav": {
    "overview": "Overview",
    "analytics": "Analytics",
    "dermaga": "Berths",
    "map": "Map",
    "schedule": "Schedule",
    "absences": "Absences",
    "arrivals": "Arrivals & Departures",
    "tambat": "Moorings",
    "requests": "Requests",
    "bookings": "Bookings",
    "billing": "Billing",
    "quotes": "Quotes",
    "invoices": "Invoices",
    "directory": "Directory",
    "customers": "Customers",
    "boats": "Vessels",
    "contracts": "Contracts",
    "logistics": "Logistics",
    "tasks": "Tasks",
    "inventory": "Inventory",
    "utilities": "Utilities",
    "settings": "Settings",
    "dev_console": "Dev Console",
    "section": {
      "Operasional": "Operations",
      "Keuangan": "Finance",
      "Manajemen": "Management",
      "Sistem": "System"
    }
  },
  "auth": {
    "profile": "My Profile",
    "light_mode": "Light Mode",
    "dark_mode": "Dark Mode",
    "logout": "Log out",
    "logout_title": "Log out",
    "logout_msg": "Are you sure you want to end this session?",
    "expand_sidebar": "Expand sidebar",
    "collapse_sidebar": "Collapse sidebar",
    "lang_switched_en": "Language set to English",
    "lang_switched_en_msg": "Full English UI is coming soon.",
    "lang_switched_id": "Language set to Indonesian",
    "lang_switched_id_msg": "Full Indonesian interface available.",
    "switch_to_en": "🇬🇧 Switch to English",
    "switch_to_id": "🇮🇩 Ganti ke Bahasa Indonesia",
    "role": {
      "SUPER_ADMIN": "Super Admin",
      "MANAGER": "Manager",
      "STAFF": "Staff",
      "VIEWER": "Viewer",
      "CUSTOMER": "Customer",
      "default": "User"
    }
  },
  "status": {
    "booking": {
      "PENDING": "Pending",
      "WAITLISTED": "Waitlisted",
      "CONFIRMED": "Confirmed",
      "DECLINED": "Declined",
      "RESERVED": "Reserved",
      "CHECKED_IN": "Moored",
      "CHECKED_OUT": "Departed",
      "CANCELLED": "Cancelled",
      "NO_SHOW": "No-show"
    },
    "contract": {
      "DRAFT": "Draft",
      "PREPARED": "Ready",
      "PENDING_REVIEW": "Under review",
      "ACTIVE": "Active",
      "EXPIRED": "Expired",
      "TERMINATED": "Terminated"
    },
    "quote": {
      "DRAFT": "Draft",
      "SENT": "Sent",
      "ACCEPTED": "Accepted",
      "REJECTED": "Declined",
      "EXPIRED": "Expired",
      "CONVERTED": "Invoiced"
    },
    "invoice": {
      "PRO_FORMA": "Pro forma",
      "DRAFT": "Draft",
      "SENT": "Sent",
      "PARTIALLY_PAID": "Partially paid",
      "PAID": "Paid",
      "OVERDUE": "Overdue",
      "CANCELLED": "Voided"
    },
    "berth": {
      "AVAILABLE": "Available",
      "OCCUPIED": "Occupied",
      "RESERVED": "Reserved",
      "MAINTENANCE": "Maintenance",
      "BLOCKED": "Unavailable"
    },
    "assignmentStatus": {
      "PENDING": "To do",
      "IN_PROGRESS": "In progress",
      "COMPLETED": "Done",
      "BLOCKED": "Blocked",
      "CANCELLED": "Cancelled"
    },
    "assignmentPriority": {
      "LOW": "Low",
      "MEDIUM": "Medium",
      "HIGH": "High",
      "URGENT": "Urgent"
    },
    "customerCategory": {
      "TRANSIT": "Transit",
      "OWNER": "Owner",
      "RENTER": "Renter",
      "MEMBER": "Member",
      "GUEST": "Guest",
      "OTHER": "Other"
    },
    "inventoryThreshold": {
      "OUT": "Out of stock",
      "LOW": "Low stock",
      "GOOD": "In stock"
    }
  },
  "palette": {
    "trigger": "Quick find",
    "placeholder": "Search anything — customers, boats, bookings, invoices…",
    "empty": "No matches",
    "empty_hint": "Try a customer name, boat name, or invoice number",
    "shortcut_hint": "Open quick find",
    "group_actions": "Quick actions",
    "group_pages": "Go to",
    "group_customers": "Customers",
    "group_boats": "Boats",
    "group_bookings": "Bookings",
    "group_invoices": "Invoices",
    "group_quotes": "Quotes",
    "group_contracts": "Contracts",
    "action_new_booking": "New booking",
    "action_new_customer": "New customer",
    "action_new_boat": "New boat",
    "action_new_quote": "New quote",
    "action_new_invoice": "New invoice",
    "action_new_contract": "New contract",
    "action_new_assignment": "New task",
    "action_new_inventory": "New inventory item",
    "footer_navigate": "to navigate",
    "footer_select": "to open",
    "footer_close": "to close",
    "searching": "Searching…"
  },
  "page": {
    "overview": {
      "title": "Overview",
      "subtitle": "Your marina at a glance today",
      "free_berths": "Available Berths",
      "occupied_berths": "Occupied Berths",
      "revenue_month": "Revenue This Month",
      "pending_requests": "Pending Requests",
      "create_booking": "Create Booking",
      "empty_requests_title": "All clear",
      "empty_requests_desc": "No pending requests.",
      "empty_bookings_title": "Quiet harbour",
      "empty_bookings_desc": "Recent bookings will appear here.",
      "insight_pending_title": "Pending requests",
      "insight_pending_sub_plural": "{{n}} bookings need a decision",
      "insight_pending_sub_one": "{{n}} booking needs a decision",
      "insight_pending_cta": "Review now",
      "insight_pending_empty": "Inbox zero — nothing waiting",
      "insight_overdue_title": "Overdue invoices",
      "insight_overdue_sub_plural": "{{n}} customers · {{amount}} outstanding",
      "insight_overdue_sub_one": "{{n}} customer · {{amount}} outstanding",
      "insight_overdue_cta": "Chase payments",
      "insight_overdue_empty": "Every invoice is current",
      "insight_late_title": "Late check-outs",
      "insight_late_sub_plural": "{{n}} boats past their departure window",
      "insight_late_sub_one": "{{n}} boat past its departure window",
      "insight_late_cta": "Check out now",
      "insight_late_empty": "All check-outs on schedule",
      "insight_today_title": "Today",
      "insight_today_sub": "{{arrivals}} arriving · {{departures}} departing",
      "insight_today_cta": "See schedule",
      "insight_revenue_title": "Revenue this month",
      "insight_revenue_mom_up": "↑ {{n}}% vs last month",
      "insight_revenue_mom_down": "↓ {{n}}% vs last month",
      "insight_revenue_mom_flat": "Same as last month",
      "insight_revenue_mom_none": "First month of activity",
      "insight_revenue_cta": "See breakdown",
      "insight_expiring_title": "Contracts expiring",
      "insight_expiring_sub_plural": "{{n}} contracts ending in the next 30 days",
      "insight_expiring_sub_one": "{{n}} contract ending in the next 30 days",
      "insight_expiring_cta": "Review renewals",
      "insight_expiring_empty": "No contracts expiring soon",
      "insight_late_detail": "{{customer}} on {{boat}} · {{hours}}h late",
      "minutes_short": "min",
      "hours_short": "h"
    },
    "analytics": {
      "title": "Marina Analytics",
      "subtitle": "Performance summary — fleet, customers & revenue",
      "tab_fleet": "Fleet",
      "tab_boat_docs": "Boat Docs",
      "tab_id_docs": "ID Docs",
      "tab_customers": "Customers",
      "tab_revenue": "Revenue"
    },
    "occupancy": {
      "map": {
        "title": "Berth Map",
        "stat_available": "Available",
        "stat_occupied": "Occupied",
        "stat_reserved": "Reserved",
        "stat_maintenance": "Maintenance",
        "btn_edit": "Edit Layout",
        "btn_done": "Done",
        "btn_cancel": "Cancel",
        "unsaved": "{{n}} unsaved",
        "saving": "Saving…",
        "placeholder_berth": "Search berths…",
        "placeholder_pontoon": "All pontoons"
      },
      "calendar": {
        "title": "Mooring Schedule",
        "btn_new": "+ New Request",
        "btn_today": "Back to today",
        "count_berths": "Berths shown",
        "count_bookings": "Moorings in period",
        "count_boats": "Unique vessels",
        "placeholder_pontoon": "All pontoons"
      },
      "absences": {
        "title": "Absences",
        "subtitle": "Berths temporarily vacated by customers",
        "stat_total": "Total absences",
        "stat_avg": "Avg. duration",
        "stat_berths": "Unique berths",
        "tab_available": "Available for Sub-let",
        "tab_blocked": "Blocked",
        "hint_available": "Temporarily vacant berths available for subletting.",
        "hint_blocked": "Vacated berths that remain blocked.",
        "col_customer": "Customer",
        "col_berth": "Berth",
        "col_period": "Absence Period",
        "col_duration": "Duration",
        "col_reason": "Reason",
        "col_status": "Status",
        "col_booking": "Booking",
        "empty_available": "No berths marked as available for sub-let",
        "empty_blocked": "No temporarily blocked berths"
      },
      "arrivals": {
        "title": "Arrivals & Departures",
        "stat_arrivals": "Arrivals",
        "stat_departures": "Departures",
        "stat_recorded": "Recorded actual",
        "stat_late": "Late > 30 min",
        "tab_all": "All",
        "tab_arrivals": "Arrivals",
        "tab_departures": "Departures",
        "placeholder": "Search vessel, customer, berth…",
        "tooltip_arrival": "Arrival",
        "tooltip_departure": "Departure",
        "no_results": "No results for \"{{q}}\""
      }
    },
    "reservations": {
      "requests": {
        "title": "Requests",
        "subtitle": "Incoming mooring requests awaiting review & approval",
        "btn_new": "+ New Booking",
        "alert_pending": "{{n}} awaiting approval",
        "alert_waitlisted": "{{n}} on waitlist",
        "tab_all": "All",
        "tab_pending": "Awaiting",
        "tab_waitlisted": "Waitlisted",
        "tab_confirmed": "Confirmed",
        "tab_declined": "Declined",
        "placeholder": "Search customer, vessel, code…"
      },
      "bookings": {
        "title": "Active Bookings",
        "subtitle": "Confirmed bookings — berthing, moored, completed",
        "btn_new": "+ New Request",
        "stat_in_marina": "Currently moored",
        "stat_reserved": "Awaiting check-in",
        "stat_completed": "Completed (all-time)",
        "tab_all": "All",
        "tab_reserved": "Berthing",
        "tab_in": "In Marina",
        "tab_out": "Departed",
        "tab_cancelled": "Cancelled",
        "placeholder": "Search customer, vessel, code…"
      },
      "detail": {
        "title": "Booking Detail",
        "subtitle": "Reservation {{code}}",
        "not_found": "Booking not found",
        "back_link": "← Back to bookings",
        "section_customer": "Customer",
        "section_boat": "Vessel",
        "section_berth": "Berth & Channel",
        "section_timeline": "Booking Timeline",
        "section_documents": "Linked Documents",
        "field_name": "Name",
        "field_email": "Email",
        "field_phone": "Phone",
        "field_country": "Country",
        "field_boat_name": "Name",
        "field_type": "Type",
        "field_loa": "LOA",
        "field_flag": "Flag",
        "field_berth": "Berth",
        "field_pontoon": "Pontoon",
        "field_channel": "Channel",
        "field_location": "Location",
        "notes_label": "Notes",
        "timeline_created": "Created",
        "timeline_confirmed": "Confirmed",
        "timeline_berth": "Berth Assigned",
        "timeline_checkin": "Check-in",
        "timeline_checkout": "Check-out",
        "timeline_planned": "{{date}} (planned)",
        "action_approve": "Approve",
        "action_waitlist": "Waitlist",
        "action_assign": "Assign Berth",
        "action_checkin": "Check-in",
        "action_checkout": "Check-out",
        "action_decline": "Decline",
        "action_cancel": "Cancel",
        "confirm_approve": "Approve booking {{code}}?",
        "confirm_waitlist": "Move {{code}} to waitlist?",
        "confirm_checkin": "Confirm check-in for {{code}} now?",
        "confirm_checkout": "Confirm check-out for {{code}} now?",
        "confirm_cancel": "Cancel booking {{code}}?",
        "notify_approved": "Booking approved",
        "notify_waitlisted": "Moved to waitlist",
        "notify_checkin": "Check-in recorded",
        "notify_checkout": "Check-out recorded",
        "notify_cancelled": "Booking cancelled",
        "modal_assign_title": "Assign Berth — {{code}}",
        "modal_assign_desc": "Select an available berth. Date overlap is checked on save.",
        "modal_assign_placeholder": "Select an available berth…",
        "modal_assign_btn": "Assign",
        "modal_decline_title": "Decline Request",
        "modal_decline_label": "Reason for Declining",
        "modal_decline_placeholder": "Explain why this booking request is being declined…",
        "modal_decline_btn": "Decline Request",
        "terminal_declined": "Booking declined.",
        "terminal_cancelled": "Booking cancelled.",
        "terminal_noshow": "No-show."
      }
    },
    "billing": {
      "quotes": {
        "title": "Quotes",
        "subtitle": "Service quotations for marina customers",
        "btn_new": "+ New Quote",
        "placeholder": "Search quotes…",
        "col_code": "Quote No.",
        "col_customer": "Customer",
        "col_total": "Total",
        "col_valid": "Valid Until",
        "col_status": "Status",
        "col_actions": "Actions",
        "tab_all": "All",
        "tab_draft": "Draft",
        "tab_sent": "Sent",
        "tab_accepted": "Accepted",
        "tab_rejected": "Rejected",
        "tab_expired": "Expired",
        "tab_converted": "Converted",
        "alert_accepted": "{{n}} quotes accepted — ready to convert to invoice",
        "alert_expired": "{{n}} quotes expired — follow up needed",
        "empty": "No quotes yet",
        "empty_accepted": "No accepted quotes yet",
        "empty_expired": "No expired quotes",
        "days_left": "{{n}} days left",
        "days_ago": "{{n}} days ago",
        "today": "Today",
        "detail": {
          "loading": "Loading quote…",
          "not_found": "Quote not found",
          "linked_invoice": "Linked invoice",
          "action_send": "Send to customer",
          "action_send_title": "Send this quote?",
          "action_send_body": "The customer will receive an email with the quote details. The reference code will be finalised.",
          "action_accept": "Mark as accepted",
          "action_accept_title": "Mark quote as accepted?",
          "action_accept_body": "Confirms the customer has approved this quote. You can create an invoice from it afterwards.",
          "action_reject": "Mark as declined",
          "action_reject_title": "Mark quote as declined?",
          "action_reject_body": "This is reversible — you can resend the quote later if the customer changes their mind.",
          "action_convert": "Create invoice",
          "convert_modal_title": "Create invoice from this quote",
          "convert_modal_body": "A draft invoice will be created with the same line items. The customer will not be charged until you send it.",
          "convert_modal_due": "Payment due date",
          "convert_modal_submit": "Create invoice"
        }
      },
      "invoices": {
        "title": "Invoices",
        "subtitle": "Billing and payments for marina customers",
        "btn_new": "+ New Invoice",
        "placeholder": "Search invoices…",
        "col_code": "Invoice No.",
        "col_customer": "Customer",
        "col_total": "Total",
        "col_due": "Due Date",
        "col_status": "Status",
        "col_actions": "Actions",
        "tab_all": "All",
        "tab_draft": "Draft",
        "tab_sent": "Sent",
        "tab_partial": "Partial",
        "tab_paid": "Paid",
        "tab_overdue": "Overdue",
        "tab_cancelled": "Cancelled",
        "alert_overdue": "{{n}} invoices overdue — chase payment now",
        "empty": "No invoices yet",
        "empty_overdue": "No overdue invoices",
        "detail": {
          "loading": "Loading invoice…",
          "not_found": "Invoice not found",
          "linked_quote": "From quote",
          "linked_booking": "From booking",
          "action_finalize": "Confirm draft",
          "action_finalize_title": "Confirm this draft?",
          "action_finalize_body": "Locks the line items so the invoice can be sent. You can still void or refund later.",
          "action_send": "Send to customer",
          "action_send_title": "Send this invoice?",
          "action_send_body": "The customer will receive an email with the invoice and payment instructions.",
          "action_record_payment": "Record payment",
          "action_void": "Void invoice",
          "action_void_title": "Void this invoice?",
          "action_void_body": "The invoice is kept for your records but no longer counts as billable. This is reversible only by support.",
          "payment_modal_title": "Record a payment",
          "payment_modal_amount": "Amount received",
          "payment_modal_method": "Payment method",
          "payment_modal_reference": "Reference (optional)",
          "payment_modal_submit": "Save payment"
        }
      },
      "quote_new": {
        "title": "New Quote",
        "subtitle": "Fill in all sections then save as draft or send directly to customer",
        "step_customer": "Customer",
        "step_boat": "Vessel",
        "step_details": "Quote Details",
        "step_items": "Line Items",
        "label_customer": "Select Customer",
        "label_boat": "Customer's Vessel",
        "placeholder_customer": "Search by name or email…",
        "placeholder_boat_no_customer": "Select a customer first",
        "placeholder_boat_empty": "Customer has no vessels",
        "placeholder_boat": "Select vessel…",
        "boat_optional": "(Optional)",
        "boat_no_customer_hint": "Select a customer first to choose a vessel.",
        "detail_title": "Quote Details",
        "detail_subtitle": "Validity period, tax rate, and notes.",
        "valid_until": "Valid Until",
        "valid_days_from_now": "Valid for {{n}} more days · {{date}}",
        "valid_today": "Valid today · {{date}}",
        "valid_expired": "Already expired · {{date}}",
        "tax_rate": "Tax Rate (%)",
        "tax_free": "0% — Tax Exempt",
        "tax_ppn": "11% — VAT",
        "notes_label": "Notes (optional)",
        "notes_desc": "Terms, conditions, or special instructions for the customer",
        "notes_placeholder": "e.g. Price valid for payment before due date...",
        "items_title": "Line Items",
        "items_subtitle": "Services and products on this quote.",
        "items_hint": "Add at least one item with a price to be able to save the quote.",
        "review_title": "Review & Send",
        "review_subtitle": "Check all details before creating.",
        "summary_title": "Quote Summary",
        "field_customer": "Customer",
        "field_boat": "Vessel",
        "field_valid": "Valid Until",
        "field_tax": "Tax Rate",
        "no_customer": "— not selected",
        "subtotal": "Subtotal",
        "tax": "VAT {{rate}}%",
        "next_details": "Next: Quote Details",
        "next_items": "Next: Line Items",
        "next_review": "Next: Review",
        "btn_cancel": "Cancel",
        "btn_draft": "Save Draft",
        "btn_send": "Send Quote",
        "notify_created": "Quote created",
        "notify_sent": "{{code}} saved & sent.",
        "notify_draft": "{{code}} saved as Draft.",
        "new_customer": "Add new customer →",
        "no_boats": "This customer has no vessels.",
        "add_boat": "Add vessel →",
        "required_badge": "Required",
        "optional_badge": "Optional",
        "done_badge": "Done"
      },
      "invoice_new": {
        "title": "New Invoice",
        "subtitle": "Invoice starts as Pro Forma — finalise and send from the detail page",
        "proforma_notice": "New invoices always start as Pro Forma. Once saved, open the invoice detail to finalise, send to the customer, or record payment.",
        "step_customer": "Customer",
        "step_boat": "Vessel",
        "step_details": "Invoice Details",
        "step_recipient": "Bill To",
        "step_items": "Charges",
        "label_customer": "Select Customer",
        "label_boat": "Customer's Vessel",
        "placeholder_customer": "Search by name or email…",
        "placeholder_boat": "Select vessel…",
        "due_date": "Due Date",
        "due_days_left": "Due in {{n}} days · {{date}}",
        "due_today": "Due today · {{date}}",
        "due_passed": "Due date has passed · {{date}}",
        "tax_rate": "Tax Rate (%)",
        "tax_free": "0% — Tax Exempt",
        "tax_ppn": "11% — VAT",
        "notes_label": "Notes (optional)",
        "notes_desc": "Internal notes or payment instructions for the customer",
        "notes_placeholder": "e.g. Transfer to account 1234567890…",
        "recipient_title": "Bill To",
        "recipient_subtitle": "Who should this invoice be billed to?",
        "recipient_same": "Use selected customer's details",
        "recipient_same_desc": "Name, email, and address will be taken from the customer profile",
        "field_name": "Name",
        "field_email": "Email",
        "field_company": "Company Name",
        "field_npwp": "Tax ID",
        "field_address": "Billing Address",
        "items_title": "Charges",
        "items_subtitle": "Services and charges on this invoice.",
        "items_hint": "Add at least one item with a price to be able to save the invoice.",
        "summary_title": "Invoice Summary",
        "field_customer": "Customer",
        "field_boat": "Vessel",
        "field_recipient": "Bill To",
        "field_due": "Due Date",
        "no_customer": "— not selected",
        "subtotal": "Subtotal",
        "tax": "VAT {{rate}}%",
        "btn_cancel": "Cancel",
        "btn_create": "Create Invoice",
        "notify_created": "Invoice created",
        "notify_proforma": "{{code}} created as Pro Forma."
      }
    },
    "accounts": {
      "customers": {
        "title": "Customers",
        "subtitle": "Registered marina customers",
        "btn_new": "+ Add Customer",
        "placeholder": "Search name or email…",
        "col_customer": "Customer",
        "col_category": "Category",
        "col_country": "Country",
        "col_boats": "Vessels",
        "col_bookings": "Bookings",
        "col_status": "Status",
        "col_actions": "Actions",
        "badge_in_marina": "Moored",
        "empty": "No customers registered yet"
      },
      "boats": {
        "title": "Vessels",
        "subtitle": "Fleet of vessels registered at the marina",
        "btn_new": "+ Add Vessel",
        "placeholder": "Search name or type…",
        "col_boat": "Vessel",
        "col_owner": "Owner",
        "col_dimensions": "Dimensions",
        "col_location": "Location",
        "col_status": "Status",
        "col_actions": "Actions",
        "empty": "No vessels registered yet",
        "in_marina": "In Marina",
        "at_sea": "At Sea",
        "unknown": "Unknown"
      },
      "contracts": {
        "title": "Contracts",
        "subtitle": "Manage long-term mooring contracts",
        "btn_new": "+ New Contract",
        "placeholder": "Search contracts…",
        "col_code": "Code",
        "col_customer": "Customer",
        "col_boat": "Vessel",
        "col_berth": "Berth",
        "col_duration": "Duration",
        "col_value": "Total Value",
        "col_status": "Status",
        "tab_all": "All",
        "tab_draft": "Draft",
        "tab_prepared": "Prepared",
        "tab_review": "Under Review",
        "tab_active": "Active",
        "tab_expired": "Expired",
        "tab_terminated": "Terminated",
        "empty": "No Contracts Yet",
        "duration_months": "{{n}} mo",
        "duration_days": "{{n}} days",
        "ai_draft_button": "AI: Draft next invoice",
        "ai_draft_title": "Draft invoice with AI",
        "ai_draft_loading": "Drafting invoice — usually takes ~5 seconds…",
        "ai_draft_subtitle": "Review the AI-suggested line items below. You can edit anything before creating the invoice.",
        "ai_draft_period_this": "This month",
        "ai_draft_period_next": "Next month",
        "ai_draft_subtotal": "Subtotal",
        "ai_draft_tax": "Tax ({{rate}}%)",
        "ai_draft_total": "Total",
        "ai_draft_due_date": "Payment due",
        "ai_draft_create": "Create draft invoice",
        "ai_draft_cancel": "Cancel",
        "ai_draft_failed": "AI couldn't draft this invoice. Try again, or create it manually.",
        "ai_draft_disabled": "AI is not configured on this server. Ask your admin to enable the proxy.",
        "ai_draft_period_label": "Billing period",
        "ai_draft_col_desc": "Description",
        "ai_draft_col_qty": "Qty",
        "ai_draft_col_price": "Unit price",
        "ai_draft_col_amount": "Amount",
        "ai_draft_success": "Draft invoice created",
        "ai_draft_only_active": "AI drafts are available only for active contracts",
        "new_title": "New Contract",
        "new_subtitle": "New long-term mooring contract for a customer",
        "step1": "Select Customer",
        "step2": "Contract Details",
        "step3": "Contract Items",
        "step4": "Documents & Notes",
        "step5": "Review Agreement",
        "next_step2": "Next: Contract Details",
        "next_step3": "Next: Contract Items",
        "next_step4": "Next: Documents & Notes",
        "next_step5": "Next: Review",
        "btn_cancel": "Cancel",
        "btn_back": "Back",
        "btn_draft": "Save Draft",
        "btn_prepared": "Mark as Prepared",
        "type_weekly": "Weekly",
        "type_monthly": "Monthly",
        "type_seasonal": "Seasonal",
        "type_annual": "Annual",
        "review_parties": "Parties",
        "review_period": "Period",
        "review_items": "Items",
        "review_signature": "Signature",
        "notify_created": "Contract created",
        "notify_prepared": "{{code}} marked as Prepared",
        "notify_draft": "{{code}} saved as Draft."
      }
    },
    "facility": {
      "tasks": {
        "title": "Tasks",
        "subtitle": "Marina staff operational tasks",
        "btn_new": "+ Create Task",
        "placeholder": "Search task title…",
        "col_title": "Title",
        "col_category": "Category",
        "col_priority": "Priority",
        "col_assigned": "Assigned to",
        "col_deadline": "Deadline",
        "col_status": "Status",
        "col_actions": "Actions",
        "tab_list": "List",
        "tab_calendar": "Calendar",
        "empty": "No tasks yet",
        "overdue": "Overdue",
        "cat_customer_support": "Customer Support",
        "cat_maintenance": "Maintenance",
        "cat_cleaning": "Cleaning",
        "cat_admin": "Admin",
        "cat_security": "Security",
        "cat_other": "Other",
        "cal_prev": "Previous month",
        "cal_next": "Next month",
        "cal_today": "Today",
        "cal_more": "more",
        "cal_no_tasks": "No tasks on this day.",
        "cal_no_deadlines": "No tasks with a deadline yet.",
        "priority_urgent": "Urgent",
        "priority_high": "High",
        "priority_medium": "Medium",
        "priority_low": "Low"
      },
      "inventory": {
        "title": "Inventory",
        "subtitle": "Marina stock and supplies",
        "btn_new": "+ Add Item",
        "placeholder": "Search item name…",
        "col_item": "Item",
        "col_category": "Category",
        "col_stock": "Stock",
        "col_status": "Status",
        "col_updated": "Updated",
        "col_actions": "Actions",
        "tab_all": "All",
        "tab_out": "Out of Stock",
        "tab_low": "Low Stock",
        "alert_out": "{{n}} items out of stock",
        "alert_low": "{{n}} items low on stock",
        "empty": "No inventory items yet"
      }
    },
    "settings": {
      "index": {
        "title": "Settings",
        "subtitle": "Configure your marina workspace",
        "card_marina": "Marina Info",
        "card_marina_desc": "Marina name, address, currency, timezone, tax, support contacts.",
        "card_berths": "Berth Management",
        "card_berths_desc": "Manage pontoons and berths — dimensions, rates, services, map positions.",
        "card_audit": "Audit Log",
        "card_audit_desc": "All user actions: bookings, invoices, status changes — for compliance.",
        "card_staff": "Staff & Roles",
        "card_staff_desc": "Invite team members, change roles, manage access permissions.",
        "card_email": "Email Templates",
        "card_email_desc": "Customise quote, invoice, and booking confirmation emails.",
        "card_notifications": "Notifications",
        "card_notifications_desc": "Notification preferences per event (in-app, email, SMS).",
        "card_security": "Security",
        "card_security_desc": "API keys, session management, data protection compliance.",
        "badge_active": "Active",
        "badge_soon": "Soon"
      },
      "marina": {
        "title": "Marina Info",
        "subtitle": "Name, location, timezone, currency, and support contacts",
        "section_identity": "Marina Identity",
        "section_location": "Location & Regional",
        "section_contact": "Support Contact",
        "field_name": "Marina Name",
        "field_name_desc": "Official name shown on invoices, quotes, and contracts",
        "field_name_placeholder": "Benoa Marina Bali",
        "field_logo": "Logo URL",
        "field_logo_desc": "Transparent PNG/SVG, min. 200px wide. Appears in document headers.",
        "field_logo_placeholder": "https://cdn.example.com/logo.png",
        "preview_label": "Shown in invoice & quote headers:",
        "field_address": "Address",
        "field_address_placeholder": "Jl. Raya Benoa, Kuta Selatan",
        "field_city": "City",
        "field_city_placeholder": "Badung",
        "field_country": "Country",
        "field_timezone": "Timezone",
        "field_currency": "Currency",
        "field_tax": "Default Tax Rate (%)",
        "field_tax_desc": "Used as the default when creating new quotes or invoices",
        "field_email": "Support Email",
        "field_email_placeholder": "support@marina.id",
        "field_email_desc": "Shown in document footers and automated emails",
        "field_phone": "Phone / WhatsApp",
        "field_phone_placeholder": "+62 812 3456 7890",
        "field_phone_desc": "Number customers can contact",
        "loading": "Loading…",
        "last_saved": "Last saved {{datetime}}",
        "btn_save": "Save Changes",
        "notify_saved": "Saved",
        "notify_saved_msg": "Marina info updated successfully"
      },
      "berths": {
        "title": "Berth Management",
        "subtitle": "Manage pontoons and berths — dimensions, utilities, rates, and map positions",
        "pontoon_section": "Pontoons ({{n}})",
        "berth_section": "Berths",
        "btn_add_pontoon": "+ Add Pontoon",
        "btn_add_berth": "+ Add Berth",
        "filter_all": "All",
        "stat_available": "{{n}} available",
        "stat_occupied": "{{n}} occupied",
        "stat_maintenance": "{{n}} maintenance",
        "col_code": "Code",
        "col_name": "Name",
        "col_berths": "Berths",
        "col_sort": "Order",
        "col_dimensions": "Max Dimensions",
        "col_utilities": "Utilities",
        "col_rate": "Daily Rate",
        "col_status": "Status",
        "empty_pontoon": "No pontoons yet — add a pontoon before creating berths",
        "empty_berth": "No berths yet",
        "empty_berth_filter": "No berths in this pontoon",
        "modal_add_pontoon": "Add Pontoon",
        "modal_edit_pontoon": "Edit Pontoon {{code}}",
        "modal_add_berth": "Add Berth",
        "modal_edit_berth": "Edit Berth {{code}}",
        "pontoon_code_label": "Code",
        "pontoon_code_desc": "Single letter or combination (A, B, VIP)",
        "pontoon_sort_label": "Display Order",
        "pontoon_sort_desc": "Lower number = appears earlier",
        "pontoon_name_label": "Name",
        "pontoon_name_desc": "Optional descriptive name",
        "berth_code_label": "Berth Code",
        "berth_code_desc": "Unique per marina (e.g. A-1, B-03, VIP-1)",
        "berth_number_label": "Number",
        "berth_pontoon_label": "Pontoon",
        "section_dimensions": "Dimensions (metres)",
        "berth_loa_label": "Max LOA",
        "berth_loa_desc": "Maximum overall vessel length",
        "berth_beam_label": "Max Beam",
        "berth_beam_desc": "Maximum vessel beam",
        "berth_draft_label": "Max Draft",
        "berth_draft_desc": "Maximum vessel draft",
        "berth_depth_label": "Water Depth",
        "berth_depth_desc": "Actual depth at this berth",
        "section_utilities": "Utilities",
        "berth_water_label": "Fresh Water",
        "berth_water_desc": "Fresh water connection available",
        "berth_electric_label": "Shore Power",
        "berth_electric_desc": "Electrical connection available",
        "berth_amperage_label": "Amperage",
        "section_rates": "Rates",
        "berth_daily_label": "Daily (IDR)",
        "berth_daily_desc": "Basis for daily booking calculation",
        "berth_monthly_label": "Monthly (IDR)",
        "berth_monthly_desc": "Optional",
        "berth_yearly_label": "Yearly (IDR)",
        "berth_yearly_desc": "Optional",
        "section_status": "Status & Notes",
        "berth_status_label": "Berth Status",
        "berth_notes_label": "Internal Notes",
        "berth_notes_desc": "Additional info for staff only (not shown to customers)",
        "berth_notes_placeholder": "e.g. Corner berth, limited crane access...",
        "confirm_del_pontoon_title": "Delete Pontoon",
        "confirm_del_pontoon_msg": "Delete pontoon {{code}}? It must be empty (no berths).",
        "confirm_del_berth_title": "Delete Berth",
        "confirm_del_berth_msg": "Delete berth {{code}}? Cannot be deleted if active bookings or contracts exist.",
        "btn_save": "Save",
        "btn_create": "Create",
        "notify_pontoon_created": "Pontoon created",
        "notify_pontoon_updated": "Pontoon updated",
        "notify_pontoon_deleted": "Pontoon deleted",
        "notify_berth_created": "Berth created",
        "notify_berth_updated": "Berth updated",
        "notify_berth_deleted": "Berth deleted",
        "err_pontoon_berths": "Pontoon may still have berths",
        "err_berth_bookings": "Berth may still have bookings"
      },
      "audit": {
        "title": "Audit Log",
        "subtitle": "History of all user actions — bookings, invoices, status changes",
        "placeholder": "Filter by action (e.g. BOOKING, LOGIN)…",
        "col_time": "Time",
        "col_user": "User",
        "col_action": "Action",
        "col_detail": "Detail",
        "col_ip": "IP",
        "empty": "No audit entries yet"
      }
    },
    "utilities": {
      "title": "Utilities",
      "subtitle": "Water & electricity management per berth via Plus Marine integration",
      "integration_title": "Plus Marine Integration",
      "integration_body1": "Utility metering & billing integration with Plus Marine will be enabled in the next phase.",
      "integration_body2": "To register, contact Plus Marine or your marina office team.",
      "integration_body3": "Coming next: per-berth consumption charts, auto-generate utility invoices, threshold alerts.",
      "coming_soon_title": "Plus Marine Integration",
      "coming_soon_body": "Utility monitoring (water, electricity) per berth is under development.",
      "login_title": "Sign In",
      "login_subtitle": "No credentials yet? Contact your marina office team",
      "email_label": "Email",
      "email_placeholder": "address@email.com",
      "password_label": "Password",
      "forgot_password": "Forgot password?",
      "btn_login": "SIGN IN",
      "footer_credit": "Powered by Plus Marine — utility provider for marinas across Indonesia.",
      "modal_title": "Integration coming soon"
    }
  },
  "component": {
    "table": {
      "empty": "No data",
      "showing": "{{first}}–{{last}} of {{total}} records"
    },
    "booking_table": {
      "col_customer": "Customer",
      "col_boat": "Vessel",
      "col_period": "Period",
      "col_channel": "Channel",
      "col_status": "Status",
      "col_code": "Booking",
      "created_prefix": "created"
    },
    "notification": {
      "title": "Notifications",
      "mark_all": "Mark all read",
      "empty": "No notifications yet"
    }
  },
  "portal": {
    "welcome": "Welcome to the Customer Portal",
    "my_bookings": "My Bookings",
    "my_invoices": "My Invoices",
    "upcoming_reservations": "Upcoming Reservations",
    "no_reservations": "No upcoming reservations",
    "no_invoices": "No invoices yet",
    "profile": "Profile"
  }
}
